<script>
    export let id = "";
    export let value = "";
    export let handleChange;
    export let placeholder = "";
    export let isRequired = false;
    export let type = "text";
    export let containerClass = "w-full";
    export let fieldName ="";
    export let min;
    export let max;
    export let hasLabel = true;
    export let isDisabled = false;
    export let errorText = "";
    export let name= "";
    export let autocomplete = "one-time-code";

    $: typeAction = (node) => node.type = type;
</script>

<div class="{containerClass}">
    {#if hasLabel}
        <label for={id} class="font-450 text-lg">{fieldName}</label>
    {/if}

    <input
        {id}
        {name}
        {min}
        {max}
        {placeholder}
        {...{type}}
        class="w-full h-11 input-home {!!errorText ? 'border-error' : ''}"
        bind:value={value}
        on:change={handleChange}
        on:blur={handleChange}
        required={isRequired}
        disabled={isDisabled}
        {autocomplete}
    >

    {#if errorText}
        <div class="pl-3 text-red-500">
            {errorText}
        </div>
    {/if}
</div>

<style>
    .input-home:disabled {
        background: rgba(211, 211, 211, 0.3);
    }
</style>
